import React from "react";
import GlobalVariable from "../../../../services/globalVar.js";

const TaxSummary = (props) => {
  const { taxSummary } = props;  
  const currency = GlobalVariable.userDet.tenantConfig.currency;

  const calculateTotal = (type) => {
    return (
      taxSummary
        ?.filter((item) => item.taxType === type)[0]
        ?.taxDetails.reduce((total, category) => total + parseFloat(category.taxAmount || 0), 0) || 0
    ).toFixed(2);
  };

  const expenseTotal = calculateTotal("Expense");
  const incomeTotal = calculateTotal("Income");
  const total = parseFloat(incomeTotal).toFixed(2) - parseFloat(expenseTotal).toFixed(2);


  return (
    <>
      {/* <div className="d-flex justify-content-between mb-3">
        <div className="col-md-4 card card-borderless  p-3">
          <strong>Expenses</strong>
          <span>{currency + expenseTotal}</span>
        </div>

        <div className="col-md-4 card card-borderless p-3">
          <strong>Income</strong>
          <span>{currency + incomeTotal}</span>
        </div>

        <div className="col-md-4 card card-borderless p-3">
          <strong>Payable</strong>
          <span>{currency + total}</span>
        </div>
      </div> */}

      <div className="row mx-auto">
        <div className="card card-borderless py-2" style={{ width: "50%", padding: "0 10px" }}>
          <h2 style={{ textAlign: "center" }}>Expenses</h2>
          <div className="d-flex justify-content-between p-2" style={{ backgroundColor: "#EAF2E3" }}>
            <strong className="m-0 d-inline-flex">Particular</strong>
            <strong className="m-0 d-inline-flex">Amount ({currency})</strong>
          </div>
          <table className="mb-2" style={{ width: "100%" }}>
            <tbody>
              {Array.isArray(taxSummary) &&
                taxSummary
                  .filter((item) => item.taxType === "Expense")[0]
                  ?.taxDetails.map((category, j) => (
                    <tr key={j} style={{ border: "1px solid rgb(224 224 224)" }}>
                      <td style={{ border: "none" }}>
                        <span className="d-flex align-items-center">{category.taxName}</span>
                      </td>
                      <td className="text-end border-0" style={{ color: category?.taxAmount < 0 ? "red" : "inherit" }}>
                        {parseFloat(category?.taxAmount).toFixed(2)}
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>

        <div className="card card-borderless py-2" style={{ width: "50%", padding: "0 10px" }}>
          <h2 style={{ textAlign: "center" }}>Income</h2>
          <div className="d-flex justify-content-between p-2" style={{ backgroundColor: "#EAF2E3" }}>
            <strong className="m-0 d-inline-flex">Particular</strong>
            <strong className="m-0 d-inline-flex">Amount ({currency})</strong>
          </div>
          <table className="mb-2" style={{ width: "100%" }}>
            <tbody>
              {Array.isArray(taxSummary) &&
                taxSummary
                  .filter((item) => item.taxType === "Income")[0]
                  ?.taxDetails.map((category, j) => (
                    <tr key={j} style={{ border: "1px solid rgb(224 224 224)" }}>
                      <td style={{ border: "none" }}>
                        <span className="d-flex align-items-center">{category.taxName}</span>
                      </td>
                      <td className="text-end border-0" style={{ color: category?.taxAmount < 0 ? "red" : "inherit" }}>
                        {parseFloat(category?.taxAmount).toFixed(2)}
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default TaxSummary;
